import { Card, Button, List } from 'antd';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useReportPacks } from './hooks/useReportPacks';
import { GenerateReportPackModal } from './GenerateReportPackModal';
import { ReportPackStatusTag } from './shared/ReportPackStatusTag';
import { useIsPreActiveCustomer } from '../../../../../../hooks/useIsPreActiveCustomer';

export function ReportPackSection({
  customerId,
  year,
  uncategorizedCount = 0,
  uncategorizedTotalCents = 0,
}: {
  customerId: string;
  year: number;
  uncategorizedCount?: number;
  uncategorizedTotalCents?: number;
}) {
  const [open, setOpen] = useState(false);
  const { data } = useReportPacks(customerId);
  const isPreActive = useIsPreActiveCustomer();
  const all = data ?? [];
  const recent = all.slice(0, 3);

  return (
    <Card>
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="m-0 text-base font-semibold">Year-End Report Packs</h3>
        {/* Generating is a write against an active-only endpoint, and the packs
            listed below are demo data for pre-active customers — so the button
            is disabled, or the 403 just comes back through this door. The
            DemoDataAlert at the top of the page explains why (same treatment as
            the pre-active controls in SavingsWidget). */}
        <Button
          type="primary"
          disabled={isPreActive}
          onClick={() => setOpen(true)}
        >
          Generate {year} Report
        </Button>
      </div>
      <List
        dataSource={recent}
        locale={{ emptyText: 'No reports generated yet.' }}
        renderItem={(p: any) => (
          <List.Item
            actions={[
              <Link key="view" to={`./report-packs/${p.report_pack_id}`}>
                View
              </Link>,
            ]}
          >
            <List.Item.Meta
              title={`${p.report_year} Accounting Report`}
              description={new Date(p.created_at).toLocaleString()}
            />
            <ReportPackStatusTag status={p.status} />
          </List.Item>
        )}
      />
      {/* Gated on `> 0`, not `> 3`: packs are annual, so "only once you have
          four" meant the full-history screen was undiscoverable for every
          customer — and for pre-active customers, who get two demo packs, it
          never appeared at all. */}
      {all.length > 0 && (
        <div style={{ marginTop: 12, textAlign: 'right' }}>
          <Link to="./report-packs">View all reports →</Link>
        </div>
      )}

      <GenerateReportPackModal
        customerId={customerId}
        year={year}
        open={open}
        onClose={() => setOpen(false)}
        uncategorizedCount={uncategorizedCount}
        uncategorizedTotalCents={uncategorizedTotalCents}
      />
    </Card>
  );
}
